// /src/renderer/analysis/rendering/layoutConfig.ts
import { AnalysisType } from './analysisConfig';
import { PANEL_CONFIG, PanelConfig } from './panelConfig';


export interface LayoutConfig {
  layoutId: AnalysisType; // preview, MPR, segmentation ..
  type?:string; // '2-2', '1/3', '1-3', '1-2', '2-1', '1-1', '1/1' ..
  panelConfig: PanelConfig[];
}


export const EMPTY_DICOM_LAYOUT_CONFIG: LayoutConfig = {
  layoutId: 'empty',
  panelConfig: [],
};
export const PREVIEW_LAYOUT_CONFIG: LayoutConfig = {
  layoutId: 'preview',
  type:'1',
  panelConfig: [PANEL_CONFIG['DICOMPanel'][0]],
};
const DICOM_LAYOUT_CONFIG: LayoutConfig = {
  layoutId: 'MPR',
  panelConfig: PANEL_CONFIG['DICOMPanel'],
};
const SEGMENTATION_LAYOUT_CONFIG: LayoutConfig = {
  layoutId: 'segmentation',
  panelConfig: PANEL_CONFIG['DICOMPanel'],
};
const WALLTHICKNESS_LAYOUT_CONFIG: LayoutConfig = {
  layoutId: 'wallthickness',
  panelConfig: PANEL_CONFIG['DICOMPanel'],
};
const AORTIC_VALVE_CALCIUM_LAYOUT_CONFIG: LayoutConfig = {
  layoutId: 'aorticValveCalcium',
  panelConfig: PANEL_CONFIG['DICOMPanel'],
};
const TAVI_LAYOUT_CONFIG: LayoutConfig = {
  layoutId: 'tavi',
  panelConfig: PANEL_CONFIG['DICOMPanel'],
};
const CALCIUM_SCORE_LAYOUT_CONFIG: LayoutConfig = {
  layoutId: 'calciumScore',
  panelConfig: PANEL_CONFIG['DICOMPanel'],
};
const EJECTION_FRACTION_LAYOUT_CONFIG: LayoutConfig = {
  layoutId: 'ejectionFraction',
  panelConfig: PANEL_CONFIG['DICOMPanel'],
};
const FAI_LAYOUT_CONFIG: LayoutConfig = {
  layoutId: 'fai',
  panelConfig: PANEL_CONFIG['CPRPanel']
};
// const ISR_LAYOUT_CONFIG: LayoutConfig = {
//   layoutId: 'isr',
//   panelConfig: PANEL_CONFIG['DICOMPanel'],
// };
const PLAQUE_LAYOUT_CONFIG: LayoutConfig = {
  layoutId: 'plaque',
  panelConfig: PANEL_CONFIG['DICOMPanel'],
};
const STENOSIS_LAYOUT_CONFIG: LayoutConfig = {
  layoutId: 'stenosis',
  panelConfig: PANEL_CONFIG['DICOMPanel'],
};

const CHAMBER_LAYOUT_CONFIG: LayoutConfig = {
  layoutId: 'chamber',
  panelConfig: PANEL_CONFIG['DICOMPanel'],
};

const FFR_LAYOUT_CONFIG: LayoutConfig = {
  layoutId: 'FFR',
  panelConfig: PANEL_CONFIG['DICOMPanel'],
};

const MYOCARDIAL_LAYOUT_CONFIG: LayoutConfig = {
  layoutId: 'myocardial',
  panelConfig: PANEL_CONFIG['DICOMPanel'],
};
//MPR
export function generateMPR111LayoutConfig(): LayoutConfig {
  return {
    ...DICOM_LAYOUT_CONFIG,
    type: '1-1-1',
    panelConfig: [
      PANEL_CONFIG['DICOMPanel'][0],
      PANEL_CONFIG['DICOMPanel'][1],
      PANEL_CONFIG['DICOMPanel'][2],
    ],
  };
}
export function generateMPR13LayoutConfig(): LayoutConfig {
  return {
    ...DICOM_LAYOUT_CONFIG,
    type: '1-3',
    panelConfig: [
      ...PANEL_CONFIG['VRPanel'],
      PANEL_CONFIG['DICOMPanel'][0],
      PANEL_CONFIG['DICOMPanel'][1],
      PANEL_CONFIG['DICOMPanel'][2],
    ],
  };
}
export function generateMPR1UN3LayoutConfig(): LayoutConfig {
  return {
    ...DICOM_LAYOUT_CONFIG,
    type: '1_3',
    panelConfig: [
      ...PANEL_CONFIG['VRPanel'],
      PANEL_CONFIG['DICOMPanel'][0],
      PANEL_CONFIG['DICOMPanel'][1],
      PANEL_CONFIG['DICOMPanel'][2],
    ],
  };
}
export function generateMPR22LayoutConfig(): LayoutConfig {
  return {
    ...DICOM_LAYOUT_CONFIG,
    type: '2-2',
    panelConfig: [
      ...PANEL_CONFIG['VRPanel'],
      PANEL_CONFIG['DICOMPanel'][0],
      PANEL_CONFIG['DICOMPanel'][1],
      PANEL_CONFIG['DICOMPanel'][2],
    ],
  };
}

//SEG
export function generateSeg13LayoutConfig(): LayoutConfig {
  return {
    ...SEGMENTATION_LAYOUT_CONFIG,
    type: '1-3',
    panelConfig: [
      PANEL_CONFIG['VRPanel'][0],
      PANEL_CONFIG['DICOMPanel'][0],
      PANEL_CONFIG['DICOMPanel'][1],
      PANEL_CONFIG['DICOMPanel'][2],
    ],
  };
}
export function generateSeg1UN3LayoutConfig(): LayoutConfig {
  return {
    ...SEGMENTATION_LAYOUT_CONFIG,
    type: '1_3',
    panelConfig: [
      PANEL_CONFIG['VRPanel'][0],
      PANEL_CONFIG['DICOMPanel'][0],
      PANEL_CONFIG['DICOMPanel'][1],
      PANEL_CONFIG['DICOMPanel'][2],
    ],
  };
}
export function generateSeg22LayoutConfig(): LayoutConfig {
  return {
    ...SEGMENTATION_LAYOUT_CONFIG,
    type: '2-2',
    panelConfig: [
      PANEL_CONFIG['VRPanel'][0],
      PANEL_CONFIG['DICOMPanel'][0],
      PANEL_CONFIG['DICOMPanel'][1],
      PANEL_CONFIG['DICOMPanel'][2],
    ],
  };
}
export function generateSeg23LayoutConfig(): LayoutConfig {
  return {
    ...SEGMENTATION_LAYOUT_CONFIG,
    type: '2-3',
    panelConfig: [
      PANEL_CONFIG['VRPanel'][0],
      ...PANEL_CONFIG['VRPanel'],
      ...PANEL_CONFIG['DICOMPanel'],
    ],
  };
}

export function generateWALL111LayoutConfig(): LayoutConfig {
  return {
    ...SEGMENTATION_LAYOUT_CONFIG,
    type: '1-1-1',
    panelConfig: [
      PANEL_CONFIG['DICOMPanel'][0],
      PANEL_CONFIG['DICOMPanel'][1],
      PANEL_CONFIG['DICOMPanel'][2],
    ],
  };
}

//WALLTHICKNESS
export function generateWALL13LayoutConfig(): LayoutConfig {
  return {
    ...WALLTHICKNESS_LAYOUT_CONFIG,
    type: '1-3',
    panelConfig: [
      PANEL_CONFIG['Surface3DPanel'][0],
      PANEL_CONFIG['DICOMPanel'][0],
      PANEL_CONFIG['DICOMPanel'][1],
      PANEL_CONFIG['DICOMPanel'][2],
    ],
  };
}
export function generateWALL1UN3LayoutConfig(): LayoutConfig {
  return {
    ...WALLTHICKNESS_LAYOUT_CONFIG,
    type: '1_3',
    panelConfig: [
      PANEL_CONFIG['Surface3DPanel'][0],
      PANEL_CONFIG['DICOMPanel'][0],
      PANEL_CONFIG['DICOMPanel'][1],
      PANEL_CONFIG['DICOMPanel'][2],
    ],
  };
}
export function generateWALL22LayoutConfig(): LayoutConfig {
  return {
    ...WALLTHICKNESS_LAYOUT_CONFIG,
    type: '2-2',
    panelConfig: [
      PANEL_CONFIG['Surface3DPanel'][0],
      PANEL_CONFIG['DICOMPanel'][0],
      PANEL_CONFIG['DICOMPanel'][1],
      PANEL_CONFIG['DICOMPanel'][2],
    ],
  };
}
export function generateWALL1111LayoutConfig(): LayoutConfig {
  return {
    ...WALLTHICKNESS_LAYOUT_CONFIG,
    type: '1-1-1-1',
    panelConfig: [
      PANEL_CONFIG['Surface3DPanel'][0],
      PANEL_CONFIG['DICOMPanel'][0],
      PANEL_CONFIG['DICOMPanel'][1],
      PANEL_CONFIG['DICOMPanel'][2],
    ],
  };
}
export function generateSeg111LayoutConfig(): LayoutConfig {
  return {
    ...WALLTHICKNESS_LAYOUT_CONFIG,
    type: '1-1-1',
    panelConfig: [
      PANEL_CONFIG['DICOMPanel'][0],
      PANEL_CONFIG['DICOMPanel'][1],
      PANEL_CONFIG['DICOMPanel'][2],
    ],
  };
}

//Aortic Valve Calcium Score
export function generateAVC22LayoutConfig(): LayoutConfig {
  return {...AORTIC_VALVE_CALCIUM_LAYOUT_CONFIG,
    type: '2-2',
    panelConfig: [
      PANEL_CONFIG['CPRPanel'][0],
      ...PANEL_CONFIG['CrossSectionPanel'],
      PANEL_CONFIG['DICOMPanel'][0],
      PANEL_CONFIG['Surface3DPanel'][0],
    ]
  }
}

export function generateTAVI3322LayoutConfig(): LayoutConfig {
  return {
    ...TAVI_LAYOUT_CONFIG,
    type: '3-3-2-2',
    panelConfig: [
      PANEL_CONFIG['CrossSectionPanel'][0],
      PANEL_CONFIG['CrossSectionPanel'][0],
      PANEL_CONFIG['CrossSectionPanel'][0],
      PANEL_CONFIG['CrossSectionPanel'][0],
      PANEL_CONFIG['CrossSectionPanel'][0],
      PANEL_CONFIG['CrossSectionPanel'][0],
      PANEL_CONFIG['CrossSectionPanel'][0],
      PANEL_CONFIG['CPRPanel'][0],
      PANEL_CONFIG['ReportPanel'][0],
      PANEL_CONFIG['VRPanel'][0],
    ],
  };
}

export function generateFFRLayoutConfig(): LayoutConfig {
  return {
    ...FFR_LAYOUT_CONFIG,
    type: 'ffr',
    panelConfig: [
      PANEL_CONFIG['Surface3DPanel'][0],
      PANEL_CONFIG['PlotPanel'][0],
      PANEL_CONFIG['DICOMPanel'][0],
    ],
  };
}

export function generateFFRCaptureLayoutConfig(): LayoutConfig {
  return {
    ...FFR_LAYOUT_CONFIG,
    type: 'ffr-capture',
    panelConfig: [
      PANEL_CONFIG['Surface3DPanel'][0],
      PANEL_CONFIG['PlotPanel'][0],
      PANEL_CONFIG['DICOMPanel'][0],
      PANEL_CONFIG['EmptyPanel'][0],
    ],
  };
}

export function generateFFR22LayoutConfig(): LayoutConfig {
  return {
    ...FFR_LAYOUT_CONFIG,
    type: '2-2',
    panelConfig: [
      PANEL_CONFIG['DICOMPanel'][0],
      PANEL_CONFIG['Surface3DPanel'][0],
      PANEL_CONFIG['DICOMPanel'][1],
      PANEL_CONFIG['DICOMPanel'][2],
    ],
  };
}

export function generateFFR122LayoutConfig(): LayoutConfig {
  return {
    ...FFR_LAYOUT_CONFIG,
    type: 'ffr-1-2-2',
    panelConfig: [
      PANEL_CONFIG['CPRPanel'][0],
      PANEL_CONFIG['DICOMPanel'][0],
      PANEL_CONFIG['Surface3DPanel'][0],
      PANEL_CONFIG['DICOMPanel'][1],
      PANEL_CONFIG['DICOMPanel'][2],
    ],
  };
}



//Plaque
export function generatePlaque522LayoutConfig(): LayoutConfig {
  return {...PLAQUE_LAYOUT_CONFIG,
    type: '5-2-2',
    panelConfig: [
      PANEL_CONFIG['CPRPanel'][0],
      PANEL_CONFIG['CPRPanel'][0],
      ...PANEL_CONFIG['CrossSectionPanel'],
      ...PANEL_CONFIG['CrossSectionPanel'],
      ...PANEL_CONFIG['CrossSectionPanel'],
      PANEL_CONFIG['PlotPanel'][0],
      PANEL_CONFIG['VRPanel'][0],
      ...PANEL_CONFIG['ReportPanel'],
      PANEL_CONFIG['DICOMPanel'][0],
    ],
  };
}

export function generateLesionStackViewLayoutConfig(): LayoutConfig {
  return {...PLAQUE_LAYOUT_CONFIG,
    type: 'lesionStackView',
    panelConfig: [
      ...PANEL_CONFIG['CrossSectionPanel'],
      ...PANEL_CONFIG['CrossSectionPanel'],
      ...PANEL_CONFIG['CrossSectionPanel'],
      ...PANEL_CONFIG['CrossSectionPanel'],
      ...PANEL_CONFIG['CrossSectionPanel'],
      ...PANEL_CONFIG['CrossSectionPanel'],
      ...PANEL_CONFIG['CrossSectionPanel'],
      PANEL_CONFIG['CPRPanel'][0],
      PANEL_CONFIG['PlotPanel'][0],
      PANEL_CONFIG['VRPanel'][0],
      PANEL_CONFIG['DICOMPanel'][0],
    ],
  };
}

export function generatePlaqueManuelLayoutConfig(): LayoutConfig {
  return {...PLAQUE_LAYOUT_CONFIG,
    type: 'plaqueManuel',
    panelConfig: [
      PANEL_CONFIG['CPRPanel'][0],
      PANEL_CONFIG['CPRPanel'][0],
      ...PANEL_CONFIG['CrossSectionPanel'],
      ...PANEL_CONFIG['CrossSectionPanel'],
      ...PANEL_CONFIG['CrossSectionPanel'],
      PANEL_CONFIG['VRPanel'][0],
      PANEL_CONFIG['DICOMPanel'][0],
    ],
  };
}

export function generateStenosis522LayoutConfig(): LayoutConfig {
  return {...STENOSIS_LAYOUT_CONFIG,
    type: '5-2-2',
    panelConfig: [
      PANEL_CONFIG['CPRPanel'][0],
      PANEL_CONFIG['CPRPanel'][0],
      ...PANEL_CONFIG['CrossSectionPanel'],
      ...PANEL_CONFIG['CrossSectionPanel'],
      ...PANEL_CONFIG['CrossSectionPanel'],
      PANEL_CONFIG['PlotPanel'][0],
      PANEL_CONFIG['VRPanel'][0],
      ...PANEL_CONFIG['ReportPanel'],
      PANEL_CONFIG['DICOMPanel'][0],
    ],
  };
}

export function generateISR522LayoutConfig(): LayoutConfig {
  return {...STENOSIS_LAYOUT_CONFIG,
    type: '5-2-2',
    panelConfig: [
      PANEL_CONFIG['CPRPanel'][0],
      PANEL_CONFIG['CPRPanel'][0],
      ...PANEL_CONFIG['CrossSectionPanel'],
      ...PANEL_CONFIG['CrossSectionPanel'],
      ...PANEL_CONFIG['CrossSectionPanel'],
      PANEL_CONFIG['PlotPanel'][0],
      PANEL_CONFIG['VRPanel'][0],
      ...PANEL_CONFIG['ReportPanel'],
      PANEL_CONFIG['DICOMPanel'][0],
    ],
  };
}

export function generateFAI132LayoutConfig(): LayoutConfig {
  return {...FAI_LAYOUT_CONFIG,
    type: '1-3-2',
    panelConfig: [
      PANEL_CONFIG['CPRPanel'][0],
      ...PANEL_CONFIG['CrossSectionPanel'],
      ...PANEL_CONFIG['CrossSectionPanel'],
      ...PANEL_CONFIG['CrossSectionPanel'],
      PANEL_CONFIG['PlotPanel'][1],
      PANEL_CONFIG['CPRPanel'][0],
      ...PANEL_CONFIG['CrossSectionPanel'],
      ...PANEL_CONFIG['CrossSectionPanel'],
      ...PANEL_CONFIG['CrossSectionPanel'],
      PANEL_CONFIG['PlotPanel'][1],
      PANEL_CONFIG['CPRPanel'][0],
      ...PANEL_CONFIG['CrossSectionPanel'],
      ...PANEL_CONFIG['CrossSectionPanel'],
      ...PANEL_CONFIG['CrossSectionPanel'],
      PANEL_CONFIG['PlotPanel'][1],
      PANEL_CONFIG['DICOMPanel'][0],
      PANEL_CONFIG['VRPanel'][0]
    ]
  }
}

export function generateCalciumScore13LayoutConfig(): LayoutConfig {
  return {...CALCIUM_SCORE_LAYOUT_CONFIG,
    type: '1-3',
    panelConfig: [
      PANEL_CONFIG['Surface3DPanel'][0],
      PANEL_CONFIG['DICOMPanel'][0],
      PANEL_CONFIG['DICOMPanel'][1],
      PANEL_CONFIG['DICOMPanel'][2],
    ]
  }
}

export function generateEF22LayoutConfig(): LayoutConfig {
  return {...EJECTION_FRACTION_LAYOUT_CONFIG,
    type: '2-2',
    panelConfig: [
      PANEL_CONFIG['VRPanel'][0],
      PANEL_CONFIG['DICOMPanel'][0],
      PANEL_CONFIG['DICOMPanel'][1],
      PANEL_CONFIG['DICOMPanel'][2],
    ]
  }
}

export function generateEF13LayoutConfig(): LayoutConfig {
  return {...EJECTION_FRACTION_LAYOUT_CONFIG,
    type: '1-3',
    panelConfig: [
      PANEL_CONFIG['VRPanel'][0],
      PANEL_CONFIG['DICOMPanel'][0],
      PANEL_CONFIG['DICOMPanel'][1],
      PANEL_CONFIG['DICOMPanel'][2],
    ]
  }
}

export function generateEF1UN3LayoutConfig(): LayoutConfig {
  return {...EJECTION_FRACTION_LAYOUT_CONFIG,
    type: '1_3',
    panelConfig: [
      PANEL_CONFIG['VRPanel'][0],
      PANEL_CONFIG['DICOMPanel'][0],
      PANEL_CONFIG['DICOMPanel'][1],
      PANEL_CONFIG['DICOMPanel'][2],
    ]
  }
}

export function generateMY1UN3LayoutConfig(): LayoutConfig {
  return {...EJECTION_FRACTION_LAYOUT_CONFIG,
    type: '1-3',
    panelConfig: [
      PANEL_CONFIG['Surface3DPanel'][0],
      PANEL_CONFIG['DICOMPanel'][0],
      PANEL_CONFIG['DICOMPanel'][1],
      PANEL_CONFIG['DICOMPanel'][2],
    ]
  }
}

export function generateChamber222LayoutConfig(): LayoutConfig {
  return {...CHAMBER_LAYOUT_CONFIG,
    type: '2-2-2',
    panelConfig: [
      PANEL_CONFIG['DICOMPanel'][0],
      PANEL_CONFIG['DICOMPanel'][3],
      PANEL_CONFIG['DICOMPanel'][6],
      PANEL_CONFIG['DICOMPanel'][5],
      PANEL_CONFIG['DICOMPanel'][4],
      PANEL_CONFIG['VRPanel'][0],
    ]
  }
}

// export function generateWallThickness13LayoutConfig(): LayoutConfig {
//   return {...WALLTHICKNESS_LAYOUT_CONFIG,}
// }

export const DEFAULT_LAYOUT_CONFIG_INDEX: Record<AnalysisType, number> = {
  'empty':0,
  'preview': 0,
  'MPR': 0,
  'segmentation':0,
  'wallthickness':0,
  'aorticValveCalcium': 0,
  'calciumScore':0,
  'ejectionFraction':0,
  'fai':0,
  'isr':0,
  'plaque':0,
  'stenosis':0,
  'chamber':0,
  'myocardial':0,
  'tavi':0,
  'FFR':0,
  // 'mri-analysis1': 0,
  // 'mri-analysis2': 0,
  // 'xa-analysis1': 0,
  // 'xa-analysis2': 0,
};

export const LAYOUT_CONFIG: Record<AnalysisType, LayoutConfig[]> = {
  'empty':[],
  'preview': [PREVIEW_LAYOUT_CONFIG],
  'MPR': [
    generateMPR22LayoutConfig(),
    generateMPR111LayoutConfig(),
    generateMPR13LayoutConfig(),
    generateMPR1UN3LayoutConfig(),
  ],
  'segmentation': [
    generateSeg22LayoutConfig(),
    generateSeg1UN3LayoutConfig(),
    generateSeg13LayoutConfig(),
    generateSeg111LayoutConfig(),
  ],
  'wallthickness': [
    generateWALL1UN3LayoutConfig(),
    generateWALL13LayoutConfig(),
    generateWALL22LayoutConfig(),
  ],
  'aorticValveCalcium':[
    generateAVC22LayoutConfig()
  ],
  'calciumScore':[
    generateCalciumScore13LayoutConfig()
  ],
  'ejectionFraction':[
    generateEF22LayoutConfig(),
    generateEF1UN3LayoutConfig(),
    generateEF13LayoutConfig()
  ],
  'fai': [
    generateFAI132LayoutConfig()
  ],
  'isr':[
    generateISR522LayoutConfig()
  ],
  'plaque':[
    generatePlaque522LayoutConfig(),
    generateLesionStackViewLayoutConfig(),
    generatePlaqueManuelLayoutConfig()
  ],
  'stenosis':[
    generateStenosis522LayoutConfig()
  ],
  'chamber':[
    generateChamber222LayoutConfig()
  ],
  'myocardial':[
    generateMY1UN3LayoutConfig()
  ],
  'tavi':[
    generateTAVI3322LayoutConfig()
  ],
  'FFR':[
    generateFFRLayoutConfig(),
    generateFFRCaptureLayoutConfig(),
    generateFFR22LayoutConfig(),
    generateFFR122LayoutConfig(),
  ],
  // 'mri-analysis1': [SINGLEDICOM_LAYOUT_CONFIG],
  // 'mri-analysis2': [SINGLEDICOM_LAYOUT_CONFIG],
  // 'xa-analysis1': [SINGLEDICOM_LAYOUT_CONFIG],
  // 'xa-analysis2': [SINGLEDICOM_LAYOUT_CONFIG],
};
